import { FC, PropsWithChildren } from 'react';

import { isIncoming } from '../../lib/itemCheckers';
import { GroupingProps, MessageAuthor, MessageBubble, MessageTime, MessageWrapper } from './ChatMessage.styles';
import CONTENT from '../content.json';

const getAuthor = ({ DisplayName, ParticipantRole }: connect.ChatTranscriptItem): string | undefined => {
  if (ParticipantRole === 'CUSTOMER') {
    return CONTENT.author.customer;
  }
  if (ParticipantRole === 'AGENT') {
    return DisplayName;
  }
  return CONTENT.author.bot;
};

export type ChatMessageProps = { item: connect.ChatTranscriptItem } & GroupingProps;

export const ChatMessageWrapper: FC<PropsWithChildren<ChatMessageProps>> = ({
  children,
  groupsWithNext,
  groupsWithPrev,
  item
}) => {
  const date = new Date(item.AbsoluteTime);
  const time = date.toLocaleString('en-AU', { hour: 'numeric', minute: 'numeric', hour12: true });
  const isIncomingMessage = isIncoming(item);

  return (
    <MessageWrapper isIncoming={isIncomingMessage} groupsWithPrev={groupsWithPrev} groupsWithNext={groupsWithNext}>
      <MessageAuthor>{getAuthor(item)}</MessageAuthor>
      <MessageBubble id={item.Id && `message_${item.Id}`} tabIndex={-1}>
        {children}
      </MessageBubble>
      <MessageTime>{time}</MessageTime>
    </MessageWrapper>
  );
};

ChatMessageWrapper.displayName = 'ChatMessageWrapper';
